import VShowBottleModal from './components/VShowBottleModal.vue'

new Vue({
    el: '#misc',
    components: { VShowBottleModal },
    name: 'Misc',
    data: {
        bottleModal: {
            image: '/images/boce/1.jpg',
            caps: ['1L', '2L', '5L'],
        },
        showModal: false,
    },
    methods: {
        showBottle(img, caps) {
            this.bottleModal.image = img;
            this.bottleModal.caps = caps;
            this.showModal = true;
        }

    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/misc.js